import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { BidMoneySvg } from './BidMoneySvg'

export const EaBidMethodIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={BidMoneySvg} {...props} />
)
